export const editMutations = <const>{
	DISPONIBILITA_SKLAD_TABLE_SCHEMA_MUTATION: 'DISPONIBILITA_SKLAD_TABLE_SCHEMA_MUTATION',
	DISPONIBILITA_SKLAD_TABLE_DATA_MUTATION: 'DISPONIBILITA_SKLAD_TABLE_DATA_MUTATION',
	PR_ORDERS_DODAVATEL_SELECT_MAPPER: 'PR_ORDERS_DODAVATEL_SELECT_MAPPER',
	PR_ORDERS_DEALER_SELECT_MAPPER: 'PR_ORDERS_DEALER_SELECT_MAPPER',
};

export interface HromadnaObjednavka {
	MioPzn?: number,
	MnozstviObj?: number,
	NdNr: string,
	SkladOzn?: string,
	VyrobekndOzn: string,
	ZakazkaId: number | null,
	ZakazkandextodpisId?: number,
	HromadnaObjednavkaRowId: string,
}


export const editActions = <const>{
	DISPONIBILITA_SKLAD_TABLE_SCHEMA: 'prorderTableSchema',
	DISPONIBILITA_SKLAD_TABLE_DATA: 'prorderTableData',

};
